module.exports = __webpack_public_path__ + "img/role_1.8c185b84.png";